import React from 'react'

const AppSafeBack = React.createContext(false)

export default AppSafeBack
